import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { generatePrompts, getGeneratedAllTopicsApi } from './query';
import ReactSelect from '../../../../../components/ReactSelect';
import Loading from '../../../../../components/Loading';
import { COUNTRIES } from '../../../create/countries';
import { LANGUAGES } from '../../../create/languages';
import ProjectEditModal from '../../../projects/modal/EditProject/modal';
import AddKeywordModal from '../addKeywordModal';
import ErrorMessage from '../../../ErrorMessage';
import PromptsView from '../PromptsView';
import DomainImage from '../../../../../components/DomainImage';
import PromptsModal from './modal';
import {
    getStoredCountryLanguage,
    resolveCountryLanguage,
    saveCountryLanguage,
} from '../../../../../helpers/aiTrackingCountryLanguage';

class ExistingTopics extends Component {
    constructor(props) {
        super(props);

        this.handleSelectCountry = this.handleSelectCountry.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.onOpenEditModal = this.onOpenEditModal.bind(this);
        this.onCloseEditModal = this.onCloseEditModal.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.openAddKeywordModal = this.openAddKeywordModal.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.onSelectPrompts = this.onSelectPrompts.bind(this);
        this.showParentOpened = this.showParentOpened.bind(this);
        this.onClickOnParentStep = this.onClickOnParentStep.bind(this);
        this.onSelectAllPrompts = this.onSelectAllPrompts.bind(this);
        this.onSelectTopic = this.onSelectTopic.bind(this);
        this.onGeneratePrompts = this.onGeneratePrompts.bind(this);
        this.onChangeCustomTopics = this.onChangeCustomTopics.bind(this);
        this.onShowExistingTopics = this.onShowExistingTopics.bind(this);
        this.getAlreadyGeneratedTopics = this.getAlreadyGeneratedTopics.bind(this);
        this.handleClickTopicPrompts = this.handleClickTopicPrompts.bind(this);
        this.onClosePromptsModal = this.onClosePromptsModal.bind(this);
        this.addActive = this.addActive.bind(this);
        this.onChangeTag = this.onChangeTag.bind(this);

        const userCountryLanguage = getStoredCountryLanguage();
        this.state = {
            selectedCollapse: ['l-0', 'r-0'],
            selectedParentCollapse: 1,
            brand: '',
            entities: [],
            errors: {},
            loading: false,
            country: userCountryLanguage?.country ?? '',
            language: userCountryLanguage?.language ?? '',
            selectedProject: '',
            isEditModalOpen: false,
            isInProgress: false,
            isInProgressTopics: false,
            prompts: [],
            selectedItems: [],
            isAddKeywordModalOpen: false,
            topics: [],
            showStep2: false,
            showStep3: false,
            generatedTopics: [],
            selectedTopics: [],
            topicsErrorMessage: '',
            alreadyGeneratedTopics: [],
            showExistingTopics: false,
            alreadyGeneratedTopicsLoading: false,
            tag: 'create_topics',
            createdTopics: [],
            selectedTopic: null,
            select_prompt_tag: 'with_prompts',
            // topics: topics,
            // showStep2: true,
        };
    }

    addActive(value) {
        return this.state.select_prompt_tag === value;
    }

    onChangeTag(value) {
        this.setState({
            select_prompt_tag: value,
        });
    }

    async getAlreadyGeneratedTopics(id) {
        try {
            if (this.abortController) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();
            this.setState({ alreadyGeneratedTopicsLoading: true, alreadyGeneratedTopics: [] });
            const res = await getGeneratedAllTopicsApi(id, this.abortController.signal);
            const data = await res.json();
            if (data?.length) {
                this.setState({
                    alreadyGeneratedTopics: data,
                    alreadyGeneratedTopicsLoading: false,
                });
            }
            this.setState({ alreadyGeneratedTopicsLoading: false });
        } catch (err) {
            if (err.name === 'AbortError') return;
            this.setState({ alreadyGeneratedTopicsLoading: false });
            console.log('err', err);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.projects) !== JSON.stringify(prevProps.projects)) {
            const selectedProject = this.props.projects.find((x) => x.is_default) ?? null;
            if (selectedProject) {
                this.setState({
                    selectedProject: selectedProject.value,
                    ...resolveCountryLanguage(selectedProject),
                });
            }
        }
        if (
            JSON.stringify(this.state.selectedProject) !==
                JSON.stringify(prevState.selectedProject) ||
            (this.props.updateExistingPrompts !== prevProps.updateExistingPrompts &&
                this.props.updateExistingPrompts > 0)
        ) {
            if (this.state.selectedProject) {
                this.getAlreadyGeneratedTopics(this.state.selectedProject);
            }
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.prompt?.toLowerCase().includes(search.toLowerCase());
        });
    }

    onOpenEditModal() {
        this.setState({ isEditModalOpen: true });
    }

    onCloseEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    openAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: true });
    }

    closeAddKeywordModal() {
        this.setState({ isAddKeywordModalOpen: false });
    }

    showOpened(name, value) {
        return this.state.selectedCollapse.includes(name) ? value ?? 'active' : '';
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse.includes(id)
                ? this.state.selectedCollapse.filter((item) => item !== id)
                : [...this.state.selectedCollapse, id],
        });
    }

    showParentOpened(name, value) {
        return this.state.selectedParentCollapse === name ? value ?? 'active' : '';
    }

    onClickOnParentStep(id) {
        this.setState({
            selectedParentCollapse: this.state.selectedParentCollapse === id ? null : id,
        });
    }

    openEditModal() {
        this.setState({ isEditModalOpen: true });
    }
    closeEditModal() {
        this.setState({ isEditModalOpen: false });
    }

    handleSelectProject = (selectedOption) => {
        const project = this.props.projects.find((x) => x.value === selectedOption) ?? null;

        this.setState({
            selectedProject: selectedOption,
            errors: { ...this.state.errors, project: null, country: null, language: null },
            ...resolveCountryLanguage(project),
        });
    };

    handleSelectCountry(data) {
        this.setState({
            country: data.value,
            language: data.language,
            errors: {
                ...this.state.errors,
                country: null,
                language: null,
            },
        });
    }

    handleSelect(value, name) {
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: null } });
    }

    async onGeneratePrompts(e) {
        try {
            e.preventDefault();
            let isError = false;
            let errors = {};

            const selectedProject = this.props.projects.find(
                (x) => x.value === this.state.selectedProject,
            );

            if (!selectedProject?.own_domain || !selectedProject?.own_product_name) {
                errors.project = this.props.t(
                    'ai_tracking.prompt_generator.brand_and_domain_required',
                );
                isError = true;
            }
            if (!this.state.country) {
                errors.country = this.props.t('ai_tracking.prompt_generator.country_required');
                isError = true;
            }
            if (!this.state.language) {
                errors.language = this.props.t('ai_tracking.prompt_generator.language_required');
                isError = true;
            }

            if (isError) {
                return this.setState((prevState) => ({
                    errors: { ...prevState.errors, ...errors },
                }));
            }

            this.setState({
                loading: true,
                showStep3: true,
                isInProgress: true,
                errorMessage: null,
                topics: [],
            });
            this.onClickOnParentStep(3);

            const formData = {
                brand_name: selectedProject?.own_product_name,
                brand_domain: selectedProject?.own_domain,
                country: this.state.country,
                language: this.state.language,
                project: this.state.selectedProject,
                topic_ids: this.state.selectedTopics,
            };

            saveCountryLanguage({
                country: this.state.country,
                language: this.state.language,
            });

            const response = await generatePrompts(formData);
            const data = await response.json();
            if (data?.status === 'completed') {
                const topics = data?.topics || [];
                this.setState({ topics, isInProgress: false });
            } else if (data.status === 'pending') {
                this.getGeneratedPrompts(data.id);
                this.setState({ isInProgress: false });
            } else if (data.status === 'failed' || response.status > 201) {
                this.setState({
                    isInProgress: false,
                    errorMessage:
                        data.error_message ??
                        data.detail ??
                        this.props.t('ai_tracking.prompt_generator.failed_to_generate_prompts'),
                });
            }
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({
            selectedItems: state.ids,
        });
    }

    onSelectPrompts(prompt) {
        this.setState({
            selectedItems: this.state.selectedItems.includes(prompt)
                ? this.state.selectedItems.filter((item) => item !== prompt)
                : [...this.state.selectedItems, prompt],
        });
    }

    onSelectAllPrompts(prompts) {
        const allSelected = prompts.every((prompt) => this.state.selectedItems.includes(prompt));
        this.setState({
            selectedItems: allSelected
                ? this.state.selectedItems.filter((item) => !prompts.includes(item))
                : [...new Set([...this.state.selectedItems, ...prompts])],
        });
    }

    onSelectTopic(topic) {
        const newTopics = this.state.selectedTopics.includes(topic)
            ? this.state.selectedTopics.filter((item) => item !== topic)
            : [...this.state.selectedTopics, topic];

        if (newTopics.length > 10) {
            this.setState({
                topicsErrorMessage: 'You can select up to 10 topics only.',
            });
            return;
        }

        this.setState({
            selectedTopics: newTopics,
            topicsErrorMessage: '',
            selectedTopic: null,
        });
    }

    onChangeCustomTopics(e) {
        this.setState({
            customTopics: e.target.value,
        });
    }

    onShowExistingTopics() {
        this.setState({
            showExistingTopics: true,
        });
    }

    handleClickTopicPrompts(topic) {
        this.setState({
            selectedTopic: topic,
        });
    }

    onClosePromptsModal() {
        this.setState({
            selectedTopic: null,
        });
    }

    render() {
        const { t } = this.props;
        const selectedProject =
            this.props.projects.find((x) => x.value === this.state.selectedProject) ?? null;

        const projectOptions = this.props.projects.map((project) => ({
            label: (
                <div className="d-flex align-items-center gap-8">
                    {project.label}{' '}
                    {project.is_default && (
                        <span className="ai-tracking-default-selected white">
                            {t('ai_tracking.global.default')}
                        </span>
                    )}
                </div>
            ),
            value: project.value,
        }));

        const tabs = (t) => [
            { id: 'with_prompts', label: 'With Prompts' },
            { id: 'needs_prompts', label: 'Need Prompts' },
        ];

        const withGeneratedPrompts =
            this.state.alreadyGeneratedTopics?.filter(
                (item) => item.generated_prompts?.length > 0,
            ) ?? [];
        const needsPrompts =
            this.state.alreadyGeneratedTopics?.filter(
                (item) => item.generated_prompts?.length === 0,
            ) ?? [];

        return (
            <>
                <div className="card">
                    <div className="card-body">
                        <div className="prompt-generator-title">
                            <div className="prompt-generator-number">1</div>
                            <div className="prompt-generator-label">
                                {t('ai_tracking.add_keyword.project')}
                                {selectedProject && (
                                    <div className="prompt-generator-selected-project">
                                        <DomainImage
                                            domain_name={selectedProject?.own_domain}
                                            size="20"
                                        />
                                        <div>{selectedProject?.own_product_name}</div>
                                        <span>{selectedProject?.own_domain}</span>
                                        <button
                                            onClick={this.onOpenEditModal}
                                            disabled={!selectedProject}
                                        >
                                            <i className="icon-pencil" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="prompt-generator-selects-box">
                            <div>
                                <ReactSelect
                                    options={projectOptions}
                                    value={selectedProject}
                                    onChange={this.handleSelectProject}
                                    blurInputOnSelect={true}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.global.project')} <span>*</span>
                                        </div>
                                    }
                                    classname="mr-0"
                                    disabled={this.props.projectLoader}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.props.projectLoader && <Loading padding="10px 0" />}
                                {this.state.errors['project'] && (
                                    <div className="error-message">
                                        {this.state.errors['project']}
                                    </div>
                                )}
                            </div>
                            <div>
                                <ReactSelect
                                    options={COUNTRIES}
                                    value={COUNTRIES.find((x) => x.value === this.state.country)}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.add_keyword.country')} <span>*</span>
                                        </div>
                                    }
                                    placeholder={t('ai_tracking.add_keyword.country')}
                                    customeOnChange={this.handleSelectCountry}
                                    blurInputOnSelect={true}
                                    classname="mr-0"
                                    disabled={this.state.loading}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.state.errors['country'] && (
                                    <div className="error-message">
                                        {this.state.errors['country']}
                                    </div>
                                )}
                            </div>

                            <div>
                                <ReactSelect
                                    options={LANGUAGES}
                                    value={LANGUAGES.find((x) => x.value === this.state.language)}
                                    label={
                                        <div className="select-label">
                                            {t('ai_tracking.add_keyword.language')} <span>*</span>
                                        </div>
                                    }
                                    placeholder={t('ai_tracking.add_keyword.language')}
                                    onChange={(e) => this.handleSelect(e, 'language')}
                                    blurInputOnSelect={true}
                                    classname="mr-0"
                                    disabled={this.state.loading}
                                    isSearchable
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                                {this.state.errors['language'] && (
                                    <div className="error-message">
                                        {this.state.errors['language']}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {!this.props.projectLoader && selectedProject && (
                    <div className="card">
                        <div className="card-body">
                            <div className="prompt-generator-title">
                                <div className="prompt-generator-number">2</div>
                                <div className="prompt-generator-label">
                                    {' '}
                                    {t('ai_tracking.prompt_generator.select_topics')}
                                </div>
                            </div>
                            {!this.state.alreadyGeneratedTopics?.length &&
                                !this.state.alreadyGeneratedTopicsLoading && (
                                    <div className="prompt-generator-subtitle">
                                        {t('global.no_data')}
                                    </div>
                                )}
                            {this.state.alreadyGeneratedTopicsLoading && (
                                <Loading padding="10px 0" />
                            )}
                            {this.state.alreadyGeneratedTopics.length > 0 && (
                                <>
                                    <div className="tags-container">
                                        {tabs(t).map((tab) => (
                                            <span
                                                className={`tab-item ${
                                                    this.addActive(tab.id) && 'active-tag'
                                                }`}
                                                key={tab.id}
                                                onClick={() => this.onChangeTag(tab.id)}
                                            >
                                                {tab.label}
                                            </span>
                                        ))}
                                    </div>
                                    <div className="prompt-generator-body-box grid-1">
                                        <div className="prompt-generator-body-box-content existing-topics">
                                            {this.state.select_prompt_tag === 'with_prompts' && (
                                                <>
                                                    <div className="prompt-generator-step-box-body topics-list-pane">
                                                        {withGeneratedPrompts?.map((topic, idx) => (
                                                            <div
                                                                key={idx}
                                                                className={`gap-10 d-flex align-items-center prompt-generator-topic-row ${
                                                                    this.state.selectedTopic?.id ===
                                                                    topic?.id
                                                                        ? 'active'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <label
                                                                    htmlFor={topic?.id}
                                                                    onClick={() =>
                                                                        topic?.generated_prompts
                                                                            ?.length > 0
                                                                            ? this.handleClickTopicPrompts(
                                                                                  topic,
                                                                              )
                                                                            : null
                                                                    }
                                                                    // className={
                                                                    //     topic?.generated_prompts
                                                                    //         ?.length > 0
                                                                    //         ? 'disabled-item'
                                                                    //         : ''
                                                                    // }
                                                                >
                                                                    {topic?.name}{' '}
                                                                </label>
                                                                {topic?.generated_prompts?.length >
                                                                    0 && (
                                                                    <button
                                                                        className="button-already-generated-prompts"
                                                                        onClick={() =>
                                                                            this.handleClickTopicPrompts(
                                                                                topic,
                                                                            )
                                                                        }
                                                                    >
                                                                        (
                                                                        <span>
                                                                            {
                                                                                topic
                                                                                    ?.generated_prompts
                                                                                    ?.length
                                                                            }
                                                                        </span>
                                                                        ){' '}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {this.state.selectedTopic ? (
                                                        <div className="prompt-generator-step-box-body topics-prompts-pane">
                                                            <PromptsModal
                                                                topic={this.state.selectedTopic}
                                                                alreadyTrackedPrompts={
                                                                    this.props.alreadyTrackedPrompts
                                                                }
                                                                projectId={
                                                                    this.state.selectedProject
                                                                }
                                                            />
                                                        </div>
                                                    ) : (
                                                        // The list pane holds a fixed share of the
                                                        // row, so without something here the right
                                                        // three quarters would just be blank until
                                                        // a topic is picked.
                                                        <div className="prompt-generator-step-box-body topics-prompts-pane topics-prompts-pane--empty">
                                                            {t(
                                                                'ai_tracking.prompt_generator.select_topic_message',
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {this.state.select_prompt_tag === 'needs_prompts' && (
                                                <div className="prompt-generator-step-box-body w-100">
                                                    {needsPrompts?.map((topic, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="gap-10 d-flex align-items-center"
                                                        >
                                                            <input
                                                                id={topic?.id}
                                                                type="checkbox"
                                                                disabled={
                                                                    topic?.generated_prompts
                                                                        ?.length !== 0
                                                                }
                                                                onChange={() =>
                                                                    this.onSelectTopic(topic?.id)
                                                                }
                                                                checked={this.state.selectedTopics.includes(
                                                                    topic?.id,
                                                                )}
                                                            />
                                                            <label
                                                                htmlFor={topic?.id}
                                                                onClick={() =>
                                                                    topic?.generated_prompts
                                                                        ?.length > 0
                                                                        ? this.handleClickTopicPrompts(
                                                                              topic,
                                                                          )
                                                                        : null
                                                                }
                                                                // className={
                                                                //     topic?.generated_prompts
                                                                //         ?.length > 0
                                                                //         ? 'disabled-item'
                                                                //         : ''
                                                                // }
                                                            >
                                                                {topic?.name}{' '}
                                                            </label>
                                                            {topic?.generated_prompts?.length >
                                                                0 && (
                                                                <button
                                                                    className="button-already-generated-prompts"
                                                                    onClick={() =>
                                                                        this.handleClickTopicPrompts(
                                                                            topic,
                                                                        )
                                                                    }
                                                                >
                                                                    (
                                                                    <span>
                                                                        {
                                                                            topic?.generated_prompts
                                                                                ?.length
                                                                        }
                                                                    </span>
                                                                    ){' '}
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {this.state.topicsErrorMessage && (
                                        <ErrorMessage
                                            warning
                                            message={this.state.topicsErrorMessage}
                                        />
                                    )}

                                    {this.state.select_prompt_tag === 'needs_prompts' && (
                                        <div className="d-flex justify-content-end mt-3 mb-5">
                                            <div className="mt-10 d-flex justify-content-end">
                                                <div>
                                                    <button
                                                        onClick={this.onGeneratePrompts}
                                                        className="button button-filled button-primary"
                                                        disabled={
                                                            this.state.selectedTopics.length ===
                                                                0 ||
                                                            this.props.promptCredits === 0 ||
                                                            this.state.isInProgress
                                                        }
                                                    >
                                                        {t(
                                                            'ai_tracking.prompt_generator.generate_prompts',
                                                        )}
                                                    </button>
                                                    <div className="prompt-generation-count">
                                                        {this.props.getCreditsLoader ? (
                                                            <Loading />
                                                        ) : (
                                                            <>
                                                                {this.props.promptCredits}{' '}
                                                                {t(
                                                                    'ai_tracking.global.prompts_generation_left',
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {!this.props.getCreditsLoader &&
                                                this.props.promptCredits === 0 && (
                                                    <ErrorMessage
                                                        message={t(
                                                            'ai_tracking.global.prompts_generation_left_message',
                                                        )}
                                                    />
                                                )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
                {this.state.showStep3 && (
                    <div className="card">
                        <div className="card-body">
                            <div className="prompt-generator-title">
                                <div className="prompt-generator-number">3</div>
                                <div className="prompt-generator-label">
                                    {' '}
                                    {t('ai_tracking.prompt_generator.select_prompts')}
                                </div>
                            </div>
                            <div>
                                {this.state.loading && (
                                    <div className="mt-20 d-flex gap-8">
                                        <strong>
                                            {t('ai_tracking.prompt_generator.generate_message')}
                                        </strong>{' '}
                                        <Loading />{' '}
                                    </div>
                                )}
                                {this.state.errorMessage && (
                                    <div className="mt-20 error-message">
                                        <strong>{this.state.errorMessage}</strong>{' '}
                                    </div>
                                )}
                            </div>
                            {!this.state.topics.length &&
                                !this.state.loading &&
                                !this.state.errorMessage && (
                                    <div className="prompt-generator-subtitle">
                                        {t('global.no_data')}
                                    </div>
                                )}

                            {this.state.topics?.length > 0 && (
                                <>
                                    <div className="prompt-generator-body-box">
                                        <div className="prompt-generator-body-box-content">
                                            {this.state.topics
                                                .filter((_, i) => i % 2 === 0)
                                                ?.map((item, i) => (
                                                    <PromptsView
                                                        item={item}
                                                        showOpened={this.showOpened}
                                                        onClickOnStep={this.onClickOnStep}
                                                        headerKey={'name'}
                                                        promptKey="generated_prompts"
                                                        selectedItems={this.state.selectedItems}
                                                        onSelectPrompts={this.onSelectPrompts}
                                                        uniqueKey={`l-${i}`}
                                                        key={i}
                                                        onSelectAllPrompts={this.onSelectAllPrompts}
                                                    />
                                                ))}
                                        </div>
                                        <div className="prompt-generator-body-box-content">
                                            {this.state.topics
                                                .filter((_, i) => i % 2 === 1)
                                                ?.map((item, i) => (
                                                    <PromptsView
                                                        item={item}
                                                        showOpened={this.showOpened}
                                                        onClickOnStep={this.onClickOnStep}
                                                        headerKey={'name'}
                                                        promptKey="generated_prompts"
                                                        selectedItems={this.state.selectedItems}
                                                        onSelectPrompts={this.onSelectPrompts}
                                                        uniqueKey={`r-${i}`}
                                                        key={i}
                                                        onSelectAllPrompts={this.onSelectAllPrompts}
                                                    />
                                                ))}
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3 mb-5">
                                        <div>
                                            <button
                                                className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center gap-8"
                                                onClick={this.openAddKeywordModal}
                                                disabled={
                                                    this.state.selectedItems.length === 0 ||
                                                    this.props.available_credits === 0
                                                }
                                            >
                                                {t(
                                                    'ai_tracking.prompt_generator.track_selected_prompts',
                                                )}
                                                <div className="selected-items-count-for-track">
                                                    {this.state.selectedItems.length}
                                                </div>
                                            </button>
                                            <div className="prompt-generation-count">
                                                {this.props.balanceLoader ? (
                                                    <Loading />
                                                ) : (
                                                    <>
                                                        {this.props.available_credits}{' '}
                                                        {t(
                                                            'ai_tracking.global.prompts_tracking_left',
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {!this.props.balanceLoader &&
                                        this.props.available_credits === 0 && (
                                            <ErrorMessage
                                                message={t(
                                                    'ai_tracking.global.prompts_tracking_left_message',
                                                )}
                                            />
                                        )}
                                </>
                            )}
                        </div>
                    </div>
                )}

                {selectedProject && this.state.isEditModalOpen && (
                    <ProjectEditModal
                        isOpen={this.state.isEditModalOpen}
                        onClose={this.onCloseEditModal}
                        item={selectedProject}
                        updateData={this.props.getProjectsData}
                    />
                )}
                {this.state.isAddKeywordModalOpen && (
                    <AddKeywordModal
                        isOpen={this.state.isAddKeywordModalOpen}
                        onClose={this.closeAddKeywordModal}
                        prompts={this.state.selectedItems}
                        projectId={this.state.selectedProject}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(ExistingTopics);
